<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <!-- <img v-if="!this.$route.query.returnTo" v-on:click="back()" :src="icon" class="icon" />
      <p class="title">ADD LOYALTY PROGRAM</p>-->
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["loyalty_programs"] }}
        </p>
      </div>
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["add_your_loyalty_card"] }}
      </p>
      <input
        v-model="label"
        :placeholder="this.$store.getters.TRANSLATIONS['enter_loyalty_program']"
        class="number"
        autocomplete="off"
      />
      <input
        v-model="code"
        :placeholder="
          this.$store.getters.TRANSLATIONS['enter_loyalty_program_num']
        "
        class="number"
        autocomplete="off"
      />
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="add()" class="button">
        {{ this.$store.getters.TRANSLATIONS["add"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      code: "",
      label: "",
      add: () => {
        let error;
        if (!this.code) {
          error = this.$store.getters.TRANSLATIONS["please_provide_loyalty"];
        }
        if (error) {
          this.$modal.show("dialog", {
            text: error,
            buttons: [
              {
                title: "OK"
              }
            ]
          });
        } else {
          const timeout = setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$http
            .post(
              `${process.env.SERVER_URL}/9A880361278149B19471CD65C5834316`,
              {
                code: this.code,
                label: this.label
              },
              {
                headers: {
                  "x-access-token": this.$storage.get("parkendaToken")
                }
              }
            )
            .then((response) => {
              console.log("Add loyalty program response");
              console.log(response);
              if (response.data && response.status && response.status === 200) {
                if (this.$route.query.returnTo) {
                  this.$router.push(`/${this.$route.query.returnTo}`);
                } else {
                  this.$router.push("/loyaltyList");
                }
              } else {
                this.$modal.show("dialog", {
                  text: this.$store.getters.TRANSLATIONS[
                    "please_provide_loyalty"
                  ],
                  buttons: [
                    {
                      title: "OK"
                    }
                  ]
                });
              }
            })
            .catch((error) => {
              let text =
                this.$store.getters.TRANSLATIONS["please_provide_loyalty"];
              if (
                error.response &&
                error.response.data &&
                error.response.data.error
              ) {
                // text = error.response.data.error;
              }
              this.$modal.show("dialog", {
                text,
                buttons: [
                  {
                    title: "OK"
                  }
                ]
              });
            })
            .finally(() => {
              clearTimeout(timeout);
              this.loading = false;
            });
        }
      },
      back: () => {
        this.$router.push("/loyaltyList");
      },
      icon: require("@/assets/icon_back.png")
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
input {
  margin: 0px 17vw 3vh;
  width: 65%;
  float: left;
  background: transparent;
  color: rgba(114, 174, 255, 1);
  border: 0;
  outline: 0;
  border-bottom: 1px solid rgba(114, 174, 255, 1);
}
input::placeholder {
  color: rgba(114, 174, 255, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/LoyaltyVouchers/Add.vue